module.exports = __webpack_public_path__ + "img/1-1.06dda5e7.jpg";